// corteCancelacion.js — ESPEJO del cuerpo de aws_lambdas/_shared_autoescuela/corteCancelacion.js («Hasta cuándo puede
// anular el alumno»). NO editar entre las marcas: se edita el canónico y
// `node aws_lambdas/_shared_autoescuela/corteCancelacionCopias.js`. La tarjeta y la vista previa de Mensajes
// automáticos lo usan para enseñar EXACTAMENTE lo que contesta el backend. Ficha:
// docs/features/autoescuela-corte-cancelacion-alumno.md

// ── corteCancelacion: cuerpo compartido (inicio) ──
const CORTE_HORAS_MIN = 1;
const CORTE_HORAS_MAX = 72;
const CORTE_HORAS_SUGERIDAS = [2, 3, 4, 6, 12, 24];

/** Horas del corte (0 = sin corte) a partir del valor guardado. Nunca lanza. PURA. */
function horasCorte(raw) {
  const v = raw && typeof raw === "object" && !Array.isArray(raw) ? raw.horas : null;
  const n = Number(v);
  return Number.isInteger(n) && n >= CORTE_HORAS_MIN && n <= CORTE_HORAS_MAX ? n : 0;
}

/**
 * Lo que se guarda: { horas } con horas 0 (apagado) o 1..72, y `tras_confirmar` (booleano) SOLO si viene en `raw` (quien
 * guarda conserva lo que había si no viene: un front viejo no lo borra). { error } si no vale. PURA.
 */
function validarCorte(raw) {
  if (raw === null) return { value: { horas: 0 } };
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return { error: "corte_cancelacion debe ser un objeto { horas }" };
  if (raw.tras_confirmar !== undefined && typeof raw.tras_confirmar !== "boolean") {
    return { error: "corte_cancelacion.tras_confirmar debe ser true o false" };
  }
  if (raw.no_laborables !== undefined && typeof raw.no_laborables !== "boolean") {
    return { error: "corte_cancelacion.no_laborables debe ser true o false" };
  }
  if (raw.horas_laborables !== undefined && typeof raw.horas_laborables !== "boolean") {
    return { error: "corte_cancelacion.horas_laborables debe ser true o false" };
  }
  const tc = {
    ...(raw.tras_confirmar !== undefined ? { tras_confirmar: raw.tras_confirmar } : {}),
    ...(raw.no_laborables !== undefined ? { no_laborables: raw.no_laborables } : {}),
    ...(raw.horas_laborables !== undefined ? { horas_laborables: raw.horas_laborables } : {}),
  };
  const n = Number(raw.horas);
  if (raw.horas === undefined || raw.horas === null || n === 0) return { value: { horas: 0, ...tc } };
  if (!Number.isInteger(n) || n < CORTE_HORAS_MIN || n > CORTE_HORAS_MAX) {
    return { error: `corte_cancelacion.horas debe ser un número entero entre ${CORTE_HORAS_MIN} y ${CORTE_HORAS_MAX} (o 0 para quitarlo)` };
  }
  return { value: { horas: n, ...tc } };
}

/** ¿La autoescuela no deja anular una práctica ya confirmada? (`tras_confirmar === true`). Nunca lanza. PURA. */
function trasConfirmar(raw) {
  return !!(raw && typeof raw === "object" && !Array.isArray(raw) && raw.tras_confirmar === true);
}

/** ¿Las horas del corte se cuentan solo en días laborables? (`horas_laborables === true`). Nunca lanza. PURA. */
function horasLaborables(raw) {
  return !!(raw && typeof raw === "object" && !Array.isArray(raw) && raw.horas_laborables === true);
}

/** ¿La autoescuela no deja anular en fin de semana ni festivo? (`no_laborables === true`). Nunca lanza. PURA. */
function noLaborables(raw) {
  return !!(raw && typeof raw === "object" && !Array.isArray(raw) && raw.no_laborables === true);
}

// Festivos NACIONALES de España (los mismos que la reserva, c_pedirPracticaFlow/reservaSlots.js): fijos + Viernes Santo.
const CORTE_FESTIVOS_FIJOS = ["01-01", "01-06", "05-01", "08-15", "10-12", "11-01", "12-06", "12-08", "12-25"];
function viernesSantoCorte(y) {
  const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
  const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
  const mes = Math.floor((h + l - 7 * m + 114) / 31), dia = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(Date.UTC(y, mes - 1, dia - 2, 12)).toISOString().slice(0, 10);
}
function partesMadridCorte(ms) {
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Madrid", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }).formatToParts(new Date(ms)).map((x) => [x.type, x.value]));
  return { y: Number(p.year), m: Number(p.month), d: Number(p.day), h: Number(p.hour), mi: Number(p.minute), ymd: `${p.year}-${p.month}-${p.day}` };
}
/** ¿«2026-10-31» es sábado, domingo o festivo nacional? PURA. */
function esYmdNoLaborable(ymd) {
  const [y, m, d] = String(ymd).split("-").map(Number);
  const dow = new Date(Date.UTC(y, m - 1, d, 12)).getUTCDay();
  if (dow === 0 || dow === 6) return true;
  return CORTE_FESTIVOS_FIJOS.includes(String(ymd).slice(5)) || ymd === viernesSantoCorte(y);
}
/** ¿El instante cae en sábado, domingo o festivo nacional en Madrid? PURA. */
function esDiaNoLaborable(nowMs) {
  if (!Number.isFinite(nowMs)) return false;
  return esYmdNoLaborable(partesMadridCorte(nowMs).ymd);
}
/** Instante de las 00:00 de Madrid del día siguiente al de `ms` (cambios de hora incluidos). PURA. */
function siguienteMedianocheMadrid(ms) {
  const p = partesMadridCorte(ms);
  const pared = Date.UTC(p.y, p.m - 1, p.d + 1, 0, 0);
  const desfase = (x) => { const q = partesMadridCorte(x); return Date.UTC(q.y, q.m - 1, q.d, q.h, q.mi) - Math.floor(x / 60000) * 60000; };
  let r = pared - desfase(pared);
  const d2 = desfase(r);
  if (pared - d2 !== r) r = pared - d2;
  return r;
}
/** Milisegundos LABORABLES (sin sábados, domingos ni festivos nacionales, en Madrid) entre `desde` y `hasta`. PURA. */
function msLaborablesEntre(desde, hasta) {
  let t = desde;
  let total = 0;
  for (let i = 0; t < hasta && i < 400; i += 1) {
    const fin = Math.min(siguienteMedianocheMadrid(t), hasta);
    if (!esDiaNoLaborable(t)) total += fin - t;
    t = fin;
  }
  return total;
}

/**
 * Por qué el ALUMNO no puede anular ESTA práctica: "confirmada" (ya la confirmó y la autoescuela tiene `tras_confirmar`),
 * "horas" (dentro del corte por horas), "no_laborable" (hoy es fin de semana o festivo y la autoescuela tiene
 * `no_laborables`) o null (sí puede). PURA.
 */
function motivoBloqueo({ horas, trasConfirmar: tc = false, noLaborables: nl = false, horasLaborables: hl = false, startIso, nowMs, confirmada = false }) {
  if (tc && confirmada === true) return "confirmada";
  if (dentroDelCorte({ horas, startIso, nowMs, laborables: hl })) return "horas";
  return nl && esDiaNoLaborable(nowMs) ? "no_laborable" : null;
}

/** Horas (con un decimal) que faltan para la práctica; null sin fecha legible. PURA. */
function horasQueFaltan(startIso, nowMs) {
  const s = Date.parse(startIso || "");
  if (!Number.isFinite(s) || !Number.isFinite(nowMs)) return null;
  return Math.round(((s - nowMs) / 3600000) * 10) / 10;
}

/**
 * ¿El ALUMNO ya no puede anular esta práctica? true si hay corte y faltan MENOS de `horas` (o ya empezó). Sin corte o
 * sin fecha legible, false (lo de siempre: fail-open). PURA.
 */
function dentroDelCorte({ horas, startIso, nowMs, laborables = false }) {
  const h = Number(horas);
  if (!(h > 0)) return false;
  const s = Date.parse(startIso || "");
  if (!Number.isFinite(s) || !Number.isFinite(nowMs)) return false;
  if (laborables) return s <= nowMs || msLaborablesEntre(nowMs, s) < h * 3600000;
  return s - nowMs < h * 3600000;
}

const CORTE_DIAS_ES = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
const CORTE_DIAS_CA = ["diumenge", "dilluns", "dimarts", "dimecres", "dijous", "divendres", "dissabte"];

/** «martes 13/10 a las 17:00» / «dimarts 13/10 a les 17:00» en hora de Madrid; "" sin fecha legible. PURA. */
function cuandoCorte(startIso, lang) {
  const ms = Date.parse(startIso || "");
  if (!Number.isFinite(ms)) return "";
  const p = Object.fromEntries(new Intl.DateTimeFormat("es-ES", {
    timeZone: "Europe/Madrid", year: "numeric", month: "numeric", day: "numeric", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }).formatToParts(new Date(ms)).map((x) => [x.type, x.value]));
  const dow = new Date(Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day))).getUTCDay();
  const ca = lang === "ca";
  return `${(ca ? CORTE_DIAS_CA : CORTE_DIAS_ES)[dow]} ${Number(p.day)}/${Number(p.month)} ${ca ? "a les" : "a las"} ${p.hour}:${p.minute}`;
}

const horasTxt = (h, lang, laborables = false) => `${h} ${Number(h) === 1 ? "hora" : lang === "ca" ? "hores" : "horas"}${
  laborables ? (lang === "ca" ? " feiners (sense comptar caps de setmana ni festius)" : " laborables (sin contar fines de semana ni festivos)") : ""}`;

/**
 * Lo que se le contesta al alumno por WhatsApp (texto libre, en la ventana que abre su propia pulsación). Con
 * `telefono` (E.164 ya formateado o no), «llámales al …»; sin él, «habla con ellos». PURA.
 */
function textoCorteAlumno({ horas, lang, cuando = "", telefono = "", motivo = "horas", laborables = false }) {
  const tel = String(telefono || "").trim();
  if (motivo === "no_laborable") {
    return lang === "ca"
      ? `Els caps de setmana i els festius no es poden anul·lar pràctiques per WhatsApp. `
        + `Ho hem passat a l'autoescola, que és qui decideix. Si és urgent, ${tel ? `truca'ls al ${tel}` : "parla-hi directament"}.`
      : `Los fines de semana y festivos no se pueden anular prácticas por WhatsApp. `
        + `Se lo hemos pasado a la autoescuela, que es quien decide. Si es urgente, ${tel ? `llámales al ${tel}` : "habla con ellos directamente"}.`;
  }
  if (motivo === "confirmada") {
    return lang === "ca"
      ? `Ja no es pot anul·lar per WhatsApp: la teva pràctica${cuando ? ` del ${cuando}` : ""} ja està confirmada. `
        + `Ho hem passat a l'autoescola, que és qui decideix. Si és urgent, ${tel ? `truca'ls al ${tel}` : "parla-hi directament"}.`
      : `Ya no se puede anular por WhatsApp: tu práctica${cuando ? ` del ${cuando}` : ""} ya está confirmada. `
        + `Se lo hemos pasado a la autoescuela, que es quien decide. Si es urgente, ${tel ? `llámales al ${tel}` : "habla con ellos directamente"}.`;
  }
  if (lang === "ca") {
    return `Ja no es pot anul·lar per WhatsApp: la teva pràctica${cuando ? ` del ${cuando}` : ""} comença en menys de ${horasTxt(horas, "ca", laborables)}. `
      + `Ho hem passat a l'autoescola, que és qui decideix. Si és urgent, ${tel ? `truca'ls al ${tel}` : "parla-hi directament"}.`;
  }
  return `Ya no se puede anular por WhatsApp: tu práctica${cuando ? ` del ${cuando}` : ""} empieza en menos de ${horasTxt(horas, "es", laborables)}. `
    + `Se lo hemos pasado a la autoescuela, que es quien decide. Si es urgente, ${tel ? `llámales al ${tel}` : "habla con ellos directamente"}.`;
}

/**
 * La línea que se añade a la lista «qué práctica cancelas» del modo cancelar ("" si no hay nada que decir). Con
 * `trasConfirmar`, además «Una práctica ya confirmada no se puede anular por aquí.». PURA.
 */
function lineaCorteLista(horas, lang, { trasConfirmar: tc = false, noLaborables: nl = false, horasLaborables: hl = false } = {}) {
  const ca = lang === "ca";
  const l = [];
  if (nl) l.push(ca ? "Els caps de setmana i els festius no es pot anul·lar per aquí." : "Los fines de semana y festivos no se puede anular por aquí.");
  if (Number(horas) > 0) {
    l.push(ca
      ? `Amb menys de ${horasTxt(horas, "ca", hl)} d'antelació ja no es pot anul·lar per aquí.`
      : `Con menos de ${horasTxt(horas, "es", hl)} de antelación ya no se puede anular por aquí.`);
  }
  if (tc) l.push(ca ? "Una pràctica ja confirmada no es pot anul·lar per aquí." : "Una práctica ya confirmada no se puede anular por aquí.");
  return l.join(" ");
}

/** Lo que dice la IA por teléfono (la llamada va en castellano). PURA. */
function textoCorteLlamada(horas, motivo = "horas", laborables = false) {
  if (motivo === "no_laborable") {
    return "Los fines de semana y festivos no se pueden anular prácticas desde aquí. "
      + "Se lo paso a la autoescuela, que es quien decide, y le dirán algo.";
  }
  if (motivo === "confirmada") {
    return "Su práctica ya está confirmada y, una vez confirmada, no se puede anular desde aquí. "
      + "Se lo paso a la autoescuela, que es quien decide, y le dirán algo.";
  }
  return `Su práctica empieza en menos de ${horasTxt(horas, "es", laborables)} y ya no se puede anular desde aquí. `
    + "Se lo paso a la autoescuela, que es quien decide, y le dirán algo.";
}

/** Nota de la petición para la oficina («fuera de plazo»). canal: "whatsapp" | "telefono". PURA. */
function notaPeticionCorte({ horas, cuando = "", faltan = null, canal = "whatsapp", lang = "es", motivo = "horas", laborables = false }) {
  const f = Number.isFinite(Number(faltan)) && faltan !== null ? Math.max(0, Number(faltan)) : null;
  if (motivo === "no_laborable") {
    return lang === "ca"
      ? `Volia anul·lar la pràctica${cuando ? ` del ${cuando}` : ""} ${canal === "telefono" ? "per telèfon" : "per WhatsApp"} en cap de setmana o festiu`
        + ` (la teva norma: aquests dies no s'anul·la). No s'ha anul·lat: decideix tu.`
      : `Quería anular la práctica${cuando ? ` del ${cuando}` : ""} ${canal === "telefono" ? "por teléfono" : "por WhatsApp"} en fin de semana o festivo`
        + ` (tu norma: esos días no se anula). No se ha anulado: decide tú.`;
  }
  if (motivo === "confirmada") {
    return lang === "ca"
      ? `Volia anul·lar la pràctica JA CONFIRMADA${cuando ? ` del ${cuando}` : ""} ${canal === "telefono" ? "per telèfon" : "per WhatsApp"}`
        + `${f !== null ? ` amb ${f} h d'antelació` : ""} (la teva norma: un cop confirmada no s'anul·la). No s'ha anul·lat: decideix tu.`
      : `Quería anular la práctica YA CONFIRMADA${cuando ? ` del ${cuando}` : ""} ${canal === "telefono" ? "por teléfono" : "por WhatsApp"}`
        + `${f !== null ? ` con ${f} h de antelación` : ""} (tu norma: una vez confirmada no se anula). No se ha anulado: decide tú.`;
  }
  if (lang === "ca") {
    return `Volia anul·lar la pràctica${cuando ? ` del ${cuando}` : ""} ${canal === "telefono" ? "per telèfon" : "per WhatsApp"}`
      + `${f !== null ? ` amb ${f} h d'antelació` : ""} (el teu límit: ${horasTxt(horas, "ca", laborables)}). No s'ha anul·lat: decideix tu.`;
  }
  return `Quería anular la práctica${cuando ? ` del ${cuando}` : ""} ${canal === "telefono" ? "por teléfono" : "por WhatsApp"}`
    + `${f !== null ? ` con ${f} h de antelación` : ""} (tu límite: ${horasTxt(horas, "es", laborables)}). No se ha anulado: decide tú.`;
}

/**
 * Aviso de la tarjeta cuando el corte deja sin efecto la cancelación tardía por WhatsApp: con la tardía activada y el
 * corte en sus horas o más, el alumno nunca puede anular por WhatsApp dentro del plazo de la tardía. null si no
 * aplica. `tardia` = late_cancellation ({ enabled, hours }; sin hours, 24 como el backend). PURA.
 */
function avisoCorteYTardia({ horas, tardia }) {
  const h = Number(horas);
  if (!(h > 0) || !tardia || tardia.enabled !== true) return null;
  const t = Number(tardia.hours) > 0 ? Number(tardia.hours) : 24;
  return h >= t ? { tipo: "tardia_sin_efecto", corte: h, tardia: t } : { tipo: "tardia_entre", corte: h, tardia: t };
}
// ── corteCancelacion: cuerpo compartido (fin) ──

export {
  CORTE_HORAS_MIN, CORTE_HORAS_MAX, CORTE_HORAS_SUGERIDAS,
  horasCorte, validarCorte, trasConfirmar, noLaborables, horasLaborables, esDiaNoLaborable, msLaborablesEntre, motivoBloqueo, horasQueFaltan, dentroDelCorte, cuandoCorte,
  textoCorteAlumno, lineaCorteLista, textoCorteLlamada, notaPeticionCorte, avisoCorteYTardia,
};
